import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './StorageNotice.css'
import { useI18n } from '@/lib/i18n'

// Not a consent banner: the site sets no cookies and stores only what its
// features need (§ 165 Abs 3 TKG 2021), and Google Maps asks on its own
// (MapEmbed). This just says so, once a year. Listed in PrivacyPage.
const KEY = 'softmaze.notice'
const YEAR = 365 * 24 * 60 * 60 * 1000

export default function StorageNotice() {
  const { section, to } = useI18n()
  const c = section('notice') as Record<string, string>

  const [visible, setVisible] = useState(false)
  const [closing, setClosing] = useState(false)

  useEffect(() => {
    try {
      localStorage.removeItem('cookieConsent') // the old consent banner's key
      const stored = localStorage.getItem(KEY)
      if (stored) {
        const { dismissedAt } = JSON.parse(stored) as { dismissedAt?: number }
        if (typeof dismissedAt === 'number' && Date.now() - dismissedAt < YEAR) return
      }
    } catch {
      /* storage unavailable: just show the notice */
    }
    const id = setTimeout(() => setVisible(true), 300)
    return () => clearTimeout(id)
  }, [])

  const dismiss = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ dismissedAt: Date.now() }))
    } catch {
      /* ignore */
    }
    setClosing(true)
    setTimeout(() => setVisible(false), 300)
  }

  if (!visible) return null

  return (
    <aside className={`storage-notice ${closing ? 'closing' : ''}`} aria-live="polite" aria-label={c.label}>
      <p>
        {c.text}{' '}
        <Link to={to('/privacy')} className="storage-notice__link">
          {c.privacy}
        </Link>
      </p>
      <div className="storage-notice__actions">
        <button type="button" className="btn btn--primary btn--sm" onClick={dismiss}>
          {c.dismiss}
        </button>
      </div>
    </aside>
  )
}
